import * as Yup from "yup";

/**
 * Validation Schema for Contact Form
 * Validates: full_name, email, country_code, phone, message_type, message
 */
export const contactFormSchema = Yup.object().shape({
  full_name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    // .max(100, "Name must be less than 100 characters")
    .required("Full name is required"),

  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),

  country_code: Yup.string()
    .required("Country code is required"),

  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),

  message_type: Yup.string()
    .oneOf(
      ["support", "vendor-partnership", "general-inquiry", "request-for-license", ""],
      "Please select a valid message type"
    )
    .test("not-empty", "Message type is required", (value) => value !== "")
    .required("Message type is required"),

  message: Yup.string()
    .min(10, "Message must be at least 10 characters")
    // .max(1000, "Message must be less than 1000 characters")
    .required("Message is required"),
});

export type ContactFormValues = Yup.InferType<typeof contactFormSchema>;

